var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRuntimeEnforcementinline = function SvgRuntimeEnforcementinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 23,
    r: 2,
    fill: "#00877C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 34,
    r: 2,
    fill: "#EB4748"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 45,
    r: 2,
    fill: "#0073E6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 56,
    r: 2,
    fill: "#FFBF00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M28 23h-5M47 34h-5M28 45h-5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00877C",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M54 23H32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EB4748",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M38 34H23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0073E6",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M52 45H32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBF00",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M41 56H23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D7E0",
    fillRule: "evenodd",
    d: "M10 13a3 3 0 0 0-3 3v47a3 3 0 0 0 3 3h35a1 1 0 1 0 0-2H10a1 1 0 0 1-1-1V16a1 1 0 0 1 1-1h51a1 1 0 0 1 1 1v23a1 1 0 1 0 2 0V16a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5D6",
    stroke: "#FFBF00",
    strokeWidth: 2,
    d: "M62.136 44.48a1 1 0 0 1 1.728 0l12.259 21.016A1 1 0 0 1 75.259 67H50.741a1 1 0 0 1-.864-1.504l12.26-21.015Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBF00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M63 51v7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 62,
    r: 1,
    fill: "#FFBF00",
    stroke: "#FFBF00"
  })));
};
export default SvgRuntimeEnforcementinline;